// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";

import { Component, createRef } from "react";
import { connect } from "react-redux";
import {
	ADD_GOODDEAL_CAMPSITE_CHANNEL,
	ADD_GOODDEAL_CAMPSITE_CITY_CHANNEL,
	DELETE_GOODDEAL_CAMPSITE_CHANNEL,
	DELETE_GOODDEAL_CAMPSITE_CITY_CHANNEL
} from "actions/types.js";
import {
	fetchSearchGooddealCampsiteChannels,
	fetchSearchGooddealCampsiteCityChannels
} from "actions/channel";
import { bindActionCreators } from "redux";
import ReactTags from "react-tag-autocomplete";
import OrganizationChannelsField from "./OrganizationChannelsField";

class Step7 extends Component {
	sendState() {
		return this.state;
	}

	constructor(props) {
		super(props);
		this.tagsRef = createRef();
		this.tagsRef2 = createRef();
	}

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_GOODDEAL_CAMPSITE_CITY_CHANNEL,
				index
			});
		}
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_GOODDEAL_CAMPSITE_CITY_CHANNEL,
			value: channel
		});
	};

	handleChannelDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_GOODDEAL_CAMPSITE_CHANNEL,
				index
			});
		}
	};

	handleChannelAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_GOODDEAL_CAMPSITE_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchGooddealCampsiteCityChannels(query);
		}
	};

	onInputCommunities = query => {
		if (query?.length > 2) {
			this.props.fetchSearchGooddealCampsiteChannels(query);
		}
	};

	render() {
		const {
			ocamping_city_channels,
			ocamping_city_channels_suggestions,
			ocamping_channels,
			ocamping_channels_suggestions,
			publishedChannelErrorMsg,
			organizationScope
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDTypography variant="h6" fontWeight="light" textAlign="center">
						{organizationScope
							? "Veuillez sélectionner le/les campings, la/les organisation(s) où publier votre annonce sur O’Camping"
							: "Veuillez sélectionner la/les villes, le/les campings, la/les organisation(s) où publier votre annonce sur O’Camping"}
					</MDTypography>
				</Grid>
				{/* Organization good deals are not published in cities */}
				{!organizationScope && (
					<Grid item xs={12}>
						<ReactTags
							ref={this.tagsRef}
							placeholderText="Villes ..."
							tags={ocamping_city_channels}
							suggestions={ocamping_city_channels_suggestions}
							minQueryLength={3}
							maxSuggestionsLength={10}
							onDelete={this.handleDelete}
							onAddition={this.handleAddition}
							suggestionsFilter={() => true}
							onInput={this.onInput}
							autoFocus={true}
							// onBlur={() => this.tagsRef2.current.focusInput()}
							removeButtonText="Cliquez pour retirer"
							inputAttributes={{
								autoComplete: "new-password"
							}}
						/>
						{publishedChannelErrorMsg && (
							<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
						)}
					</Grid>
				)}
				<Grid item xs={12}>
					<ReactTags
						ref={this.tagsRef2}
						placeholderText="Campings ..."
						tags={ocamping_channels}
						suggestions={ocamping_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleChannelDelete}
						onAddition={this.handleChannelAddition}
						suggestionsFilter={() => true}
						onInput={this.onInputCommunities}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
				<Grid item xs={12}>
					<OrganizationChannelsField communityType="Campsite" />
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetching,
		publishedCities,
		publishedCityErrorMsg,
		suggestions,
		ocamping_city_channels,
		ocamping_city_channels_suggestions,
		ocamping_channels,
		ocamping_channels_suggestions,
		publishedChannelErrorMsg,
		organizationScope
	} = state.gooddealReducer;
	return {
		suggestions,
		publishedCities,
		publishedCityErrorMsg,
		isFetching,
		ocamping_city_channels: Object.values(ocamping_city_channels),
		ocamping_city_channels_suggestions: Object.values(
			ocamping_city_channels_suggestions
		),
		ocamping_channels: Object.values(ocamping_channels),
		ocamping_channels_suggestions: Object.values(ocamping_channels_suggestions),
		publishedChannelErrorMsg,
		organizationScope
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchGooddealCampsiteCityChannels,
			fetchSearchGooddealCampsiteChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step7);
